import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=d043d556&scoped=true"
import script from "./CardHeader.vue?vue&type=script&lang=js"
export * from "./CardHeader.vue?vue&type=script&lang=js"
import style0 from "./CardHeader.vue?vue&type=style&index=0&id=d043d556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d043d556",
  null
  
)

export default component.exports